import React from 'react';
import { Heading } from 'src/components/Form';
import Button from 'src/components/Button';
import Col from 'src/components/Col';
import Row from 'src/components/Row';
import Checkbox from 'src/components/Checkbox';
import Toggle from 'src/components/Toggle';
import LoadState from 'src/components/LoadState/LoadState';
import { variables } from 'src/Tenants';
import { useNotificationSettings } from 'src/pages/Settings/CustomHooks/useNotificationSettings';
import { NoteNotification } from 'src/pages/Settings/types';
import '../../Settings.scss';
import './Notificationssection.scss';

const NOTE_OPTIONS: Array<{
  key: keyof NoteNotification;
  label: string;
  column: 'left' | 'right';
}> = [
  { key: 'serviceRequests', label: 'Service Requests', column: 'left' },
  { key: 'properties', label: 'Properties', column: 'left' },
  { key: 'suites', label: `${variables.Suite}s`, column: 'left' },
  { key: 'assets', label: 'Assets', column: 'right' },
  { key: 'inventoryItems', label: 'Inventory Items', column: 'right' },
  { key: 'contacts', label: 'Contacts', column: 'right' },
];

export const NotificationsSection: React.FC = () => {
  const {
    settings,
    isLoading,
    isDirty,
    isHomeOwnerOrOccupant,
    toggleAllowEmail,
    toggleAllowStatus,
    toggleAllowNotes,
    toggleNoteNotification,
    handleSave,
  } = useNotificationSettings();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSave();
  };

  if (isLoading && !settings) {
    return (
      <div className="settingsSection">
        <LoadState isLoading>{null}</LoadState>
      </div>
    );
  }

  if (!settings) return null;

  const leftOptions: any = NOTE_OPTIONS.filter((o) => o.column === 'left');
  const rightOptions: any = NOTE_OPTIONS.filter((o) => o.column === 'right');

  return (
    <form onSubmit={onSubmit}>
      <div className="settingsSection">
        <Heading>Notifications</Heading>

        <div className="settingsItem">
          <Toggle
            label="Allow Email Notifications"
            value={settings.allowEmail}
            onToggle={toggleAllowEmail}
          />
        </div>
        <div className="settingsItem">
          <Toggle
            label="Status Updates"
            description="These are notifications about service requests activity, like when a service request is assigned to you or changes status."
            value={settings.allowStatus}
            onToggle={toggleAllowStatus}
          />
        </div>
        {!isHomeOwnerOrOccupant && (
          <div className="settingsItem">
            <Toggle
              label="Notes"
              description="These are notifications for notes on the following:"
              value={settings.allowNotes}
              onToggle={toggleAllowNotes}
            />
          </div>
        )}
        {settings.allowNotes && (
          <div className="settingsItem">
            <Row>
              <Col xs={12} md={6}>
                {leftOptions.map(({ key, label }) => (
                  <Checkbox
                    key={key}
                    label={label}
                    value={settings.noteNotification[key]}
                    onChange={() => toggleNoteNotification(key)}
                  />
                ))}
              </Col>
              <Col xs={12} md={6}>
                {rightOptions.map(({ key, label }) => (
                  <Checkbox
                    key={key}
                    label={label}
                    value={settings.noteNotification[key]}
                    onChange={() => toggleNoteNotification(key)}
                  />
                ))}
              </Col>
            </Row>
          </div>
        )}
        <div className="notifications-save-actions">
          <Button
            label="Save Notification Changes"
            size="small"
            color="teal"
            submit
            disabled={!isDirty || isLoading}
          />
        </div>
      </div>
    </form>
  );
};